





























import { Component, Vue, Prop } from 'vue-property-decorator';
import { ConditionViewModel } from '../models/conditionViewModel';
import { OperationPickerOption, Conditions, ConditionOperationType } from '../models/conditions';
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';

@Component({
	mixins: [validationMixin],
	validations: {
		liveCondition: {
			value: { required }
		},
	}
})
export default class TextCondition extends Vue {
	@Prop() public condition: ConditionViewModel;

	public liveCondition: ConditionViewModel = {
		attribute: '',
		operation: '',
		type: '',
		value: '',
		result: true
	};

	public operations: OperationPickerOption[] = Conditions.Operations.text.map((op, index) => {
		return {
			id: `${index}`,
			title: op.title,
			operation: op.operation,
			result: op.result
		};
	});

	public selectedOperationId: string = '';

	public mounted() {
		if (this.condition) {
			this.liveCondition = {
				attribute: this.condition.attribute,
				operation: this.condition.operation,
				type: this.condition.type,
				value: this.condition.value,
				result: this.condition.result,
				unit: this.condition.unit,
				invalid: this.condition.invalid
			};

			if (this.liveCondition.invalid) {
				this.$v.$touch();
			}
		}

		this.selectedOperationId = this.getSelectedOperation();
		this.operationSelected();
	}

	public getSelectedOperation() {
		if (this.liveCondition) {
			const selectedOperation = this.operations.find(op => op.operation === this.liveCondition.operation && op.result === this.liveCondition.result);
			if (selectedOperation) {
				return selectedOperation.id;
			}
		}

		const defaultOperation = this.operations[0].id;
		return defaultOperation;
	}

	public operationSelected() {
		const selectedOperation = this.operations.find(op => op.id === this.selectedOperationId);
		if (selectedOperation) {
			this.liveCondition.operation = selectedOperation.operation;
			this.liveCondition.result = selectedOperation.result;
			this.emitConditionChanged();
		}
	}

	public textChanged(value: string) {
		this.liveCondition.value = value;
		this.$v.$touch();
		this.emitConditionChanged();
	}

	public get requiresInput() {
		return this.liveCondition.operation !== ConditionOperationType.IsSet;
	}

	private emitConditionChanged() {
		this.liveCondition.invalid = this.$v.$invalid && this.requiresInput;
		this.$emit('changed', this.liveCondition);
	}

	private complete() {
		this.liveCondition.invalid = this.$v.$invalid && this.requiresInput;
		this.$emit('completed', this.liveCondition);
	}
}
